import { Controller } from "@hotwired/stimulus";
import i18n from "../lib/i18n";

export default class extends Controller {
  static values = {
    min: Number,
    max: Number,
  };
  static targets = ["selected", "emptyPanel", "card"];

  connect() {
    this.element.addEventListener("keydown", this.preventSubmit);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.preventSubmit);
  }

  toggle(event) {
    const group = event.currentTarget.parentElement;
    group.classList.toggle("is-open");
    event.currentTarget.classList.toggle("is-expanded");
  }

  createComponentCard(element) {
    const name = element.dataset.componentName;
    const id = element.dataset.componentId;
    const category = element.dataset.category;
    const unit = element.dataset.unit;

    const componentCard = document.createElement("div");
    componentCard.setAttribute(
      "class",
      "manage-components-selected-list__item manage-components-selected-list__item--highlighted"
    );
    componentCard.setAttribute("data-component-selection-target", "card");
    componentCard.setAttribute("data-cy", "component-card");
    componentCard.setAttribute("data-component-id", id);
    componentCard.innerHTML = `
        <div class="manage-components-selected-list__item-description">
          <div class="manage-components-selected-list__item-title">${name}</div>
          <div class="manage-components-selected-list__item-meta">${category}</div>
        </div>
        <div class="manage-components-selected-list__item-input">
          <input name="facility_component_selection_form[facility_components][][component_id]" id="facility_component_selection_form[facility_components][][component_id]" type="hidden" value="${id}" />
          <input name="facility_component_selection_form[facility_components][][name]" id="facility_component_selection_form[facility_components][][name]" type="hidden" value="${name}" />
          <div class="flex gap-8 align-items-center">
            <input name="facility_component_selection_form[facility_components][][amount]" id="facility_component_selection_form[facility_components][][amount]" type="number" min="${this.minValue}" max="${this.maxValue}" data-cy="amount-input" />
            <span class="amount-unit">${unit}</span>
          </div>
        </div>
        <button type="button" data-cy="remove-btn" class="manage-components-selected-list__item-deselect-button" title="${i18n.t("js.stimulus_controllers.component_selection.remove_component")}" data-action="click->component-selection#removeComponent">
          <i class="fa fa-trash-alt destructive" data-controller="tooltip" title="${i18n.t("js.stimulus_controllers.component_selection.remove_component")}"></i>
        </button>
      `.trim();
    return componentCard;
  }

  selectComponent(event) {
    const optionEl = event.currentTarget.parentElement;

    const card = this.createComponentCard(event.currentTarget);
    this.emptyPanelTarget.classList.add("hidden");
    this.selectedTarget.appendChild(card);
    card.scrollIntoView({ behavior: "smooth", container: "nearest" });
    optionEl.classList.add("is-selected");
  }

  removeComponent(event) {
    event.stopPropagation();
    const componentCard = event.currentTarget.parentElement;
    const componentId = componentCard.dataset.componentId;
    const optionEl = document.getElementById(`component-${componentId}`);

    this.selectedTarget.removeChild(componentCard);

    if (
      !this.cardTargets.some(
        (element) => element.dataset.componentId == componentId
      )
    ) {
      optionEl.classList.remove("is-selected");
    }

    if (this.cardTargets.length === 0) {
      this.emptyPanelTarget.classList.remove("hidden");
    }
  }

  preventSubmit(event) {
    if (event.key === "Enter" && event.target.tagName === "INPUT") {
      event.preventDefault();
    }
  }
}
